/*
 * @Author: vinc
 * @LastEditTime: 2020-11-04 09:56:35
 */
let data = {
  dev: {
    'api': 'http://172.18.68.89:8001',
    'url': '',
  },
  master: {
    'api': 'http://172.17.12.236:8084',
    'url': '',
  },
  release: {
    'api': 'https://flgateway.qx.com',
    'url': '',
  },
}
module.exports = data;


// WEBPACK FOOTER //
// ./src/assets/js/http.js